module.exports = __webpack_public_path__ + "img/BatResidentielO.046a0cb4.png";